// Descripción "Sobre esta clase" por categoría (session_type.name).
// Prioridad en el componente: session.observations > esta descripción (según idioma) > texto genérico.
// Las claves deben coincidir EXACTO con el nombre del tipo de sesión (seeder PlanSessionTypeSeeder).
const CATEGORY_DESCRIPTIONS = {
  'Full Body': {
    es: 'Entrenamiento completo que trabaja todos los grupos musculares en una sola sesión para ganar fuerza y resistencia de forma equilibrada.',
    en: 'A complete workout that trains every muscle group in one session to build balanced strength and endurance.'
  },
  'Cardio & Core': {
    es: 'Combina trabajo cardiovascular con ejercicios de core para mejorar tu resistencia y fortalecer la zona media.',
    en: 'Combines cardiovascular work with core exercises to boost endurance and strengthen your midsection.'
  },
  Cardio: {
    es: 'Sesión enfocada en elevar tu ritmo cardíaco, quemar calorías y mejorar tu capacidad aeróbica.',
    en: 'A session focused on raising your heart rate, burning calories and improving aerobic capacity.'
  },
  'Upper Body & Core': {
    es: 'Fortalece tu tren superior (pecho, espalda, hombros y brazos) y el core para una base sólida y una postura firme.',
    en: 'Strengthens your upper body (chest, back, shoulders, arms) and core for a solid base and firm posture.'
  },
  'Lower Body Quads': {
    es: 'Trabajo de tren inferior con énfasis en cuádriceps: potencia y estabilidad para tus piernas.',
    en: 'Lower-body work with a focus on quads: power and stability for your legs.'
  },
  'Lower Body Glutes': {
    es: 'Tren inferior enfocado en glúteos: tonificación, fuerza y activación de la cadena posterior.',
    en: 'Lower body focused on glutes: toning, strength and posterior-chain activation.'
  },
  Core: {
    es: 'Sesión dedicada a la zona media: abdomen, lumbares y estabilizadores para un centro fuerte.',
    en: 'A session dedicated to your midsection: abs, lower back and stabilizers for a strong center.'
  },
  'Consulta de Valoración': {
    es: 'Evaluación inicial con tu entrenador para conocer tu estado físico y definir tus metas y tu plan de trabajo.',
    en: 'An initial assessment with your trainer to understand your fitness level and define your goals and plan.'
  },
  Pilates: {
    es: 'Control, respiración y movimiento consciente para mejorar postura, flexibilidad y fuerza profunda.',
    en: 'Control, breathing and mindful movement to improve posture, flexibility and deep strength.'
  },
  'Fit Dance': {
    es: 'Cardio divertido al ritmo de la música: quema calorías mientras te diviertes bailando.',
    en: 'Fun cardio to the beat of the music: burn calories while you enjoy dancing.'
  },
  'Combat Training': {
    es: 'Entrenamiento inspirado en artes marciales: potencia, coordinación y una gran descarga de energía.',
    en: 'Martial-arts-inspired training: power, coordination and a great energy release.'
  },
  Stretching: {
    es: 'Estiramiento y movilidad consciente para liberar tensión, mejorar tu rango de movimiento y recuperar.',
    en: 'Mindful stretching and mobility to release tension, improve range of motion and recover.'
  },
  'Consulta Nutrición': {
    es: 'Asesoría nutricional personalizada para alinear tu alimentación con tus objetivos.',
    en: 'Personalized nutrition guidance to align your diet with your goals.'
  },
  'Consulta Nutrición COL': {
    es: 'Asesoría nutricional personalizada para alinear tu alimentación con tus objetivos.',
    en: 'Personalized nutrition guidance to align your diet with your goals.'
  },
  'Consulta Médica': {
    es: 'Valoración médica deportiva para entrenar de forma segura y cuidar tu salud.',
    en: 'Sports medical assessment to train safely and take care of your health.'
  },
  'Sport Coaching': {
    es: 'Acompañamiento y técnica para optimizar tu rendimiento y prevenir lesiones.',
    en: 'Guidance and technique to optimize your performance and prevent injuries.'
  },
  'Coordinación y propiocepción': {
    es: 'Ejercicios de control, equilibrio y conciencia corporal para moverte mejor y prevenir lesiones.',
    en: 'Control, balance and body-awareness drills to move better and prevent injuries.'
  },
  'Fundamentos técnicos': {
    es: 'Aprende y perfecciona la técnica de los movimientos base para entrenar con seguridad y eficacia.',
    en: 'Learn and refine the technique of the base movements to train safely and effectively.'
  },
  'Asesoría Fitness Col': {
    es: 'Acompañamiento fitness personalizado para guiarte hacia tus objetivos.',
    en: 'Personalized fitness guidance to steer you toward your goals.'
  },
  'active plus': {
    es: 'Clases grupales en el club incluidas en tu membresía Active Plus: entrena en comunidad con la energía del grupo y el acompañamiento de tu entrenador.',
    en: 'Group classes at the club included in your Active Plus membership: train in community with the energy of the group and your trainer\'s guidance.'
  }
};

// Índice en minúsculas para una búsqueda tolerante a mayúsculas ("active plus" / "Active Plus").
const LOWER_INDEX = Object.keys(CATEGORY_DESCRIPTIONS).reduce((acc, key) => {
  acc[key.toLowerCase()] = CATEGORY_DESCRIPTIONS[key];
  return acc;
}, {});

export const getCategoryDescription = (category, lang = 'es') => {
  if (!category) return null;
  const entry = CATEGORY_DESCRIPTIONS[category] || LOWER_INDEX[category.toLowerCase()];
  if (!entry) return null;
  return entry[lang] || entry.es || null;
};

export default CATEGORY_DESCRIPTIONS;
